/**
 * Noramlize URL from Contentful and bring it to images.ctfassets.net
 */
export function normalizeContentfulBase(raw?: string | null): string | null {
    if (!raw) return null;
  
    // prepend protocol if needed
    let url = raw.startsWith("//") ? `https:${raw}` : raw;
  
    try {
      const u = new URL(url.includes("://") ? url : `https://${url}`);
      // change host to images CDN (only there fm/q/w/h/dpr work)
      const host = u.host
        .replace("assets.ctfassets.net", "images.ctfassets.net")
        .replace("downloads.ctfassets.net", "images.ctfassets.net");
  
      u.host = host;
      return u.toString();
    } catch {
      return null;
    }
  }
  
  /**
   * Parse string "?fm=webp&q=70" to object
   */
  function paramsFromSuffix(suffix?: string): Record<string, string> {
    if (!suffix) return {};
    const s = suffix.trim().replace(/^[?&]/, "");
    const out: Record<string, string> = {};
    s.split("&").forEach((pair) => {
      const [k, v] = pair.split("=");
      if (k) out[decodeURIComponent(k)] = v ? decodeURIComponent(v) : "";
    });
    return out;
  }
  
  /**
    * Build final URL for image with optimization parameters
   * @param raw base URL (from Contentful)
   * @param suffix string of parameters (for example "?fm=webp&q=70&w=640")
   */
  export function buildContentfulUrl(
    raw?: string | null,
    suffix?: string
  ): string {
    const base = normalizeContentfulBase(raw);
    if (!base) return "";
  
    const u = new URL(base);
    const existing = new URLSearchParams(u.search);
    const extra = paramsFromSuffix(suffix);
  
    // merge: extra overrides existing
    Object.entries(extra).forEach(([k, v]) => existing.set(k, v));
    u.search = existing.toString();
  
    return u.toString();
  }
  